import React from "react";

export default function DeclineButton({
  children,
  label,
  className = "fp-ai-btn fp-ai-btn--decline",
  type = "button",
  ...props
}) {
  return (
    <button type={type} className={className} {...props}>
      {label || children || "Decline"}
    </button>
  );
}
